export { default as Categorias } from './Categorias';
